import React, { useState } from 'react';
import {
  Button,
  Col,
  message,
  notification,
  Form,
  Row,
  Table,
  Tag,
  Typography,
} from 'antd';
import {
  LoadingOutlined,
  FileDoneOutlined,
  EditOutlined,
} from '@ant-design/icons';
import { SearchBar } from '../Atoms/SearchBar';
import { aSearchElements, oInitState } from './OrderConstants';
import { generateQueries } from '../../Utils/query';
import { useFetchOrders } from '../../Hooks/Order.hook';
import { InvoiceActions } from './InvoiceActions';
import {
  process,
  SAVE,
  UPDATE,
  GET,
  STAMP_INVOICE,
  SEND_INVOICE,
  FIND,
} from '../../Service/Api';
import { useSelector } from 'react-redux';
import moment from 'moment';

const { Text } = Typography;

export const OrderTable = () => {
  const [search, setSearch] = useState(oInitState);
  const [orders, loading, change, updater] = useFetchOrders();
  const [modal, setModal] = useState(false);
  const [modalSecondModule, setModalSecondModule] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [selected, setSelected] = useState({});
  const [formRef] = Form.useForm();
  const { user } = useSelector(state => state.auth);

  const aColumns = [
    {
      dataIndex: 'folio',
      title: 'Folio',
    },
    {
      dataIndex: 'serie',
      title: 'Serie',
    },
    {
      dataIndex: 'branch',
      title: 'Sucursal',
      render: ({ trade_name, slug }) => (
        <>
          <Text>{`${trade_name}`}</Text>
          <Text type="secondary">{` (${slug})`}</Text>
        </>
      ),
    },
    {
      dataIndex: 'fecha',
      title: 'Fecha Orden',
      render: fecha => (
        <>
          {new Date(fecha).toLocaleString('es-MX', {
            timeZone: 'America/Mexico_City',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          })}
        </>
      ),
    },
    {
      dataIndex: 'total_bruto',
      title: 'Subtotal',
      render: total_bruto => <>$ {total_bruto && total_bruto.toFixed(2)}</>,
    },
    {
      dataIndex: 'total_neto',
      title: 'Total Neto',
      render: total_neto => <>$ {total_neto && total_neto.toFixed(2)}</>,
    },
    {
      dataIndex: 'status',
      title: 'Estatus',
      render: status =>
        status ? (
          <Tag color="#87d068">Activo</Tag>
        ) : (
          <Tag color="#f50">Inactivo</Tag>
        ),
    },
    {
      dataIndex: 'id',
      title: 'Acciones',
      render: (_, row) =>
        row.status_invoice === 0 ? (
          <Row gutter={[12, 12]}>
            <Col>
              <Button
                type="primary"
                shape="circle"
                onClick={() => {
                  setSelected(row);
                  formRef.setFieldsValue({
                    ...row,
                    fecha: row.fecha,
                  });
                  setModalSecondModule(true);
                }}
              >
                <EditOutlined />
              </Button>
            </Col>
            {row.status === 1 ? (
              <Col>
                <Button
                  shape="circle"
                  onClick={() => {
                    setSelected(row);
                    setModal(true);
                  }}
                >
                  <FileDoneOutlined />
                </Button>
              </Col>
            ) : (
              <></>
            )}
          </Row>
        ) : (
          <Row>
            <Tag color="#7444C8">Facturada</Tag>
          </Row>
        ),
    },
  ];

  const handleReset = () => {
    setSearch(oInitState);
    change();
  };

  const handleSubmit = async values => {
    setModalLoading(true);
    try {
      console.log('selected TEST', selected);
      console.log('values TEST', values);
      let currentOrder;
      let isFullInvoice = selected.total_neto === values.total;

      if (isFullInvoice) {
        // Facturación total: usar orden original SIN marcarla como facturada aún
        console.log('enter if TEST - Full invoice');
        currentOrder = { data: selected };
      } else {
        console.log('enter else TEST - Partial invoice');
        // Facturación parcial: actualizar orden original y crear nueva orden
        const updatedBruto = Number(
          (selected.total_bruto - values.total / 1.16).toFixed(2)
        );
        const updatedTotal = Number(
          (selected.total_neto - values.total).toFixed(2)
        );
        const updatedOrder = await process(
          UPDATE,
          'orders',
          { total_bruto: updatedBruto, total_neto: updatedTotal },
          { id: selected.id }
        );
        console.log('updateOldOrder', updatedOrder);

        // Crear nueva order
        let detelle_ticket = [];
        let detelle_pago = [];
        let status_invoice = 0;
        let sCodigo = generateCode(15);
        const ALIASESPERA = '';
        const serie_n = 'B';
        let payloadNewOrder = {
          branch_id: selected.branch_id,
          folio: `${selected.folio}`,
          serie: selected.serie,
          total_bruto: Number((values.total / 1.16).toFixed(2)),
          total_neto: Number(values.total.toFixed(2)),
          status: 1,
          detelle_ticket,
          detelle_pago,
          status_invoice,
          ALIASESPERA,
          serie_n,
        };
        payloadNewOrder.fecha = new Date(selected.fecha);
        payloadNewOrder.codigo = sCodigo;
        currentOrder = await process(SAVE, 'orders', payloadNewOrder);
      }
      console.log('test values', values);
      const stringMethod = values.payment_method.split('&');
      const oPaymentMethodCode = stringMethod[0];
      const oPaymentMethodId = stringMethod[1];

      const stringForm = values.payment_form.split('&');
      const oPaymentFormCode = stringForm[0];
      const oPaymentFormId = stringForm[1];

      let resClient = await process(GET, 'clients', {}, { id: values.cliente });

      let oClienteRegimen = await process(
        FIND,
        'regimes',
        {},
        { queries: `id=${resClient?.data.regime_id}`, skip: 0 }
      );
      let oInvoiceUse = await process(
        FIND,
        'invoice-uses',
        {},
        { queries: `id=${resClient?.data.use_id}`, skip: 0 }
      );
      let oBranch = await process(
        GET,
        'branches',
        {},
        { id: selected.branch_id }
      );
      let oBranchRegimen = await process(
        FIND,
        'regimes',
        {},
        { queries: `id=${oBranch?.data?.regime_id}`, skip: 0 }
      );

      let oXMLInvoice = {
        order: currentOrder.data,
        client: resClient.data,
        branch: oBranch?.data,
        email: values.email,
        subtotal: Number((values.total / 1.16).toFixed(2)),
        metodoPago: oPaymentMethodCode,
        formaPago: oPaymentFormCode,
        clientRegime: oClienteRegimen?.data?.data[0].code,
        invoiceUse: oInvoiceUse?.data?.data[0].code,
        branchRegime: oBranchRegimen?.data?.data[0].code,
      };

      console.log(oXMLInvoice);
      let responseInvoice = await process(
        STAMP_INVOICE,
        'invoices',
        oXMLInvoice
      );
      console.log(responseInvoice);
      if (responseInvoice.status === 200) {
        if (!responseInvoice?.data?.status) {
          message.error(`Error en timbrado ${responseInvoice?.data?.error}`);
          return;
        } else {
          let incidencias =
            responseInvoice?.data?.stamp?.Incidencias?.Incidencia;

          if (Array.isArray(incidencias) && incidencias.length > 0) {
            message.error(`Incidencia: ${incidencias[0].MensajeIncidencia}`);
            return;
          }
          let oInvoice = {
            order_id: currentOrder.data.id,
            branch_id: currentOrder.data.branch_id,
            client_id: resClient.data.id,
            use_id: resClient.data.use_id,
            form_id: oPaymentFormId,
            method_id: oPaymentMethodId,
            invoicing_date: moment().format(),
            stamping_date: moment().format(),
            subtotal: Number((values.total / 1.16).toFixed(2)),
            cfdi: responseInvoice?.data?.stamp?.xml,
            serie: currentOrder.data.serie,
            folio: `${currentOrder.data.folio}`,
            stamping_state: 1,
            status: 1,
            sat_uuid: responseInvoice?.data?.stamp?.UUID,
            complements: `${responseInvoice?.data?.stamp?.UUID}`,
            qr: `${responseInvoice?.data?.stamp?.UUID}`,
            errors: `${responseInvoice?.data?.stamp?.UUID}`,
          };

          let response = await process(SAVE, 'invoices', oInvoice);
          if (response?.status === 201) {
            message.success(
              'Factura timbrada correctamente, enviando email...'
            );

            let oSendInvoice = {
              email: values.email,
              cfdi: btoa(responseInvoice?.data?.stamp?.xml),
              serie: currentOrder.data.serie,
              folio: currentOrder.data.folio,
              fecha_order: currentOrder.data.fecha,
            };
            let rSendInvoice = await process(
              SEND_INVOICE,
              'invoices',
              oSendInvoice
            );
            if (rSendInvoice.status === 200) {
              if (rSendInvoice?.data?.status === 200) {
                message.success(rSendInvoice?.data?.message);
              } else {
                message.error(rSendInvoice?.data?.error);
              }
            } else {
              message.error('Error al enviar correo');
            }

            // Marcar orden como facturada SOLO después de que todo fue exitoso
            let newResponse = await process(
              UPDATE,
              'orders',
              { status_invoice: 1 },
              { id: currentOrder.data.id }
            );

            if (!newResponse?.ok) {
              message.error(`Error al actualizar orden para ${values.email}`);
            } else {
              message.success('Orden marcada como facturada correctamente');
            }
          }
        }
      }

      setModalLoading(false);
      setModalSecondModule(false);
      formRef.resetFields();
      setSelected({});
      setModal(false);
      updater();
    } catch (error) {
      console.error('Error general en handleSubmit:', error);
      setModalLoading(false);
      message.error('Error general al procesar las facturas');
    }
  };

  const generateCode = long => {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < long) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  };
  const handleOrders = async values => {
    setModalLoading(true);
    let response;
    if (selected?.id) {
      let updated_by = user.id;
      let payload = {
        ...values,
        updated_by,
      };
      payload.fecha = new Date(
        new Date(payload.fecha).getTime() + 12 * 60 * 60 * 1000
      );
      response = await process(UPDATE, 'orders', payload, {
        id: selected.id,
      });
    } else {
      let detelle_ticket = [];
      let detelle_pago = [];
      let created_by = user.id;
      let status_invoice = 0;
      let sCodigo = generateCode(15);

      const ALIASESPERA = '';
      const serie_n = 'B';

      let payload = {
        ...values,
        detelle_ticket,
        detelle_pago,
        status_invoice,
        created_by,
        ALIASESPERA,
        serie_n,
      };
      payload.fecha = new Date(
        new Date(payload.fecha).getTime() + 12 * 60 * 60 * 1000
      );
      payload.codigo = sCodigo;

      response = await process(SAVE, 'orders', payload);
      console.log('RESPONSE NEW ORDER', response);
    }
    setModalLoading(false);
    if (response.ok) {
      setModalSecondModule(false);
      formRef.resetFields();
      updater();
    } else {
      const { data } = response;
      if (data?.code === 400) {
        let sErrors = '';
        if (Array.isArray(data.errors)) {
          for (const oError of data.errors) {
            if (oError.type === 'unique violation') {
              sErrors += `El valor ${oError.path} ya existe en BD\n`;
            }
          }
        } else {
          for (const sKey in data?.errors) {
            sErrors += data.errors[sKey] + '\n';
          }
        }
        message.error(data?.message);
        if (sErrors !== '') {
          notification.error({
            message: sErrors,
            title: 'Errores',
          });
        }
      } else if (data?.code === 409) {
        message.error('Valor duplicado');
      } else {
        message.error('Error en planes');
      }
    }
  };

  const handleSearch = () => change(generateQueries(search, aSearchElements));

  return (
    <div>
      <Row justify="space-between">
        <Col className="screen-title">
          <h3>Ordenes</h3>
          <h3>
            <Tag>{orders?.total >= 0 ? orders.total : <LoadingOutlined />}</Tag>
          </h3>
        </Col>
        <Col>
          <Button onClick={() => setModalSecondModule(true)} type="primary">
            Crear
          </Button>
        </Col>
      </Row>
      <SearchBar
        elements={aSearchElements}
        {...{
          handleReset,
          handleSearch,
          search,
          setSearch,
        }}
      />

      <InvoiceActions
        fn={{
          handler: setModalLoading,
          handlerSelected: setSelected,
          selected: selected,
        }}
        modal={{
          form: formRef,
          handler: setModal,
          loading: modalLoading,
          submit: handleSubmit,
          visible: modal,
        }}
        modalSecondModule={{
          form: formRef,
          handler: setModalSecondModule,
          loading: modalLoading,
          submit: handleOrders,
          visible: modalSecondModule,
        }}
      />
      <Table
        columns={aColumns}
        dataSource={orders?.data}
        loading={loading}
        pagination={{
          current: orders?.skip ? orders.skip / 10 + 1 : 1,
          onChange: e =>
            change(
              generateQueries(search, aSearchElements),
              (e - 1) * orders.limit
            ),
          pageSizeOptions: [10],
          total: orders.total,
        }}
        rowKey={row => row.id}
      />
    </div>
  );
};
